import { ethers } from "ethers";
import { toast } from "react-toastify";
import { isExpired, decodeToken } from "react-jwt";
import { Context } from "./Context";
export const showDate = (date, format = 'd m y') => {
    if (!date) return '---';
    const dateObj = new Date(date);
    const day = dateObj.getDate().toString().padStart(2, '0');
    const dayString = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][dateObj.getDay()];
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][dateObj.getMonth()];
    const year = dateObj.getFullYear();
    switch (format.toLowerCase()) {
        case 'd m y':
            return `${day} ${month} ${year}`;
        case 'd d m y':
            return `${dayString}, ${day} ${month} ${year}`;
        case 'd m':
            return `${day} ${month}`;
        case 'm d':
            return `${month} ${year}`;
        case 'h:m:sa':
            return dateObj.toLocaleTimeString();
        default:
            return `${day} ${month} ${year}`;
    }
};
export const isLogin = () => {
    try {
        const token = localStorage.getItem("token");
        if (!token || isExpired(token)) return false;
        const decoded = decodeToken(token);
        if (!decoded) return false
        return decoded
    } catch (err) {
        return false;
    }
};

export const thmeeMode = ({ theme=false }={}) => {
    const body = document.querySelector('body');
    const isLight = body.classList.contains('crypt-light');
    let themeObj = { mode: isLight ? 'crypt-light' : 'crypt-dark' }
    const themeSession = localStorage.getItem('token');
    if (themeSession) {
        const tokenString = atob(themeSession)
        const tokenObj = tokenString? JSON.parse(tokenString):{}
        themeObj = {...themeObj, ...tokenObj}
    }
    theme && (themeObj = { ...themeObj, mode: themeObj.mode == 'crypt-light' ? 'crypt-dark' : 'crypt-light' })
    body.classList.remove('crypt-light', 'crypt-dark');
    body.classList.add(themeObj.mode);
    const themeToken = btoa(JSON.stringify(themeObj))
    localStorage.setItem('token',themeToken);
    return themeObj;
}

export const connectWallet = async () => {
    if (!window.ethereum) {
        toast.info("Please install a compatible wallet extension to use BEP-20 features.", { position: "top-center", autoClose: 700 });
        return null
    }
    try {
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        const walletAddress = await signer.getAddress();
        return { provider, signer, walletAddress }
    } catch (error) {
        console.error(error);
        return error
    }
};

export const fetchBalance = async () => {
    try {
        const { provider, signer, walletAddress } = await connectWallet()
        if (!provider) return
        const network = await provider.getNetwork();
        if (network.chainId !== 56n) {
            try {
                await window.ethereum.request({ method: "wallet_switchEthereumChain", params: [{ chainId: "0x38" }] });
            } catch (switchError) {
                console.error("Switch network error:", switchError);
                return;
            }
        }
        const ERC20_ABI = [
            "function balanceOf(address owner) view returns (uint256)",
            "function decimals() view returns (uint8)",
            "function symbol() view returns (string)"
        ];
        const contract = new ethers.Contract(process.env.REACT_APP_USDT_CONTRACT_ADDRESS, ERC20_ABI, provider);
        const balanceRaw = await contract.balanceOf(walletAddress);
        const decimals = await contract.decimals();
        const balance = ethers.formatUnits(balanceRaw, decimals);
        const symbol = await contract.symbol();

        return { provider, signer, walletAddress, balance, decimals, symbol }
    } catch (err) {
        console.log("Error fetching balance:", err);
    }
}

export const sendBEP20 = async ({ to, amount = 0 }) => {
    try {
        const { provider, signer, walletAddress, balance, decimals, symbol } = await fetchBalance();
        if (!provider) return;
        if (balance < amount) {
            toast.warn('Insufficient balance', { position: 'top-center', autoClose: 700 });
            return
        }

        const network = await provider.getNetwork();
        if (network.chainId !== 56n) {
            try {
                await window.ethereum.request({
                    method: "wallet_switchEthereumChain",
                    params: [{ chainId: "0x38" }], // BSC Mainnet
                });
                toast.info("Switched to Binance Smart Chain");
            } catch (switchError) {
                console.error("Switch network error:", switchError);
                toast.error("Please switch to Binance Smart Chain manually");
                return;
            }
        }
        const BEP20_ABI = [
            "function balanceOf(address owner) view returns (uint256)",
            "function decimals() view returns (uint8)",
            "function symbol() view returns (string)",
            "function transfer(address to, uint256 amount) returns (bool)"
        ];
        const contract = new ethers.Contract(
            process.env.REACT_APP_USDT_CONTRACT_ADDRESS,
            BEP20_ABI,
            signer
        );

        const amountToSend = ethers.parseUnits(amount.toString(), decimals);
        const tx = await contract.transfer(to, amountToSend);
        const receipt = await tx.wait();
        return { walletAddress, to, amount, tx, receipt };

    } catch (err) {
        if (err.reason === 'rejected') {
            toast.warn("Transaction rejected by user", { position: "top-center", autoClose: 700 });
        } else {
            const errormessage = err.reason || err.data?.message || err.error?.message || err.message || "Unknown error occurred";
            toast.warn(errormessage, { position: "top-center", autoClose: 700 });
        }
        return err
    }
};

